module.exports = __webpack_public_path__ + "img/Split.082e1001.svg";